import { IntakeForm } from '@/types/TCallLogs';
import { Card, List, Avatar, Typography } from 'antd';
import { QuestionCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const CallInakeFormCard = ({
	intakeForm,
	style,
}: {
	intakeForm: IntakeForm[];
	style?: React.CSSProperties;
}) => {
	return (
		<Card className="bg-white rounded-xl" style={style} bodyStyle={{ padding: '20px' }}>
			<List
				dataSource={intakeForm}
				renderItem={(item, index) =>
					item && (
						<List.Item
							key={index}
							className="border-none py-3 px-0 w-full"
							style={{
								display: 'flex',
								justifyContent: item.key === 'Question' ? 'flex-start' : 'flex-end',
							}}
						>
							{/* Question (left side) */}
							{item.key === 'Question' && (
								<div className="flex items-start gap-2 max-w-[75%]">
									<Avatar
										icon={<QuestionCircleOutlined />}
										className="bg-purple-500 text-white shadow-md h-8 w-8 mt-1"
									/>
									<div className="p-3 px-4 rounded-xl shadow-sm flex flex-col gap-1 bg-purple-50">
										<Text className="text-[13px] font-semibold text-purple-500">Question</Text>
										<Text className="text-sm text-slate-700">{item.value}</Text>
									</div>
								</div>
							)}

							{/* Answer (right side) */}
							{item.key === 'Answer' && (
								<div className="flex items-start gap-2 max-w-[75%]">
									<div className="p-3 px-4 rounded-xl shadow-sm flex flex-col gap-1 bg-blue-50">
										<Text className="text-[13px] font-semibold text-blue-500">Answer</Text>
										<Text className="text-sm text-slate-700">{item.value}</Text>
									</div>
									<Avatar
										icon={<CheckCircleOutlined />}
										className="bg-blue-500 text-white shadow-md h-8 w-8 mt-1"
									/>
								</div>
							)}
						</List.Item>
					)
				}
			/>
		</Card>
	);
};
